"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var IconCardWrapper = (0, styled_1.default)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            position: 'absolute'
        },
        _b[theme.breakpoints.down('md')] = {
            bottom: theme.spacing(-1),
            left: theme.spacing(-0.5),
        },
        _b[theme.breakpoints.up('md')] = {
            top: theme.spacing(5.55),
            right: theme.spacing(0),
        },
        _b);
});
exports.default = IconCardWrapper;
